import {
    MAP_UPDATE,
    MAP_STATIC_IMAGE_URL_UPDATE,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const initialState = appInitialState.map;

/**
 * This is the application state's map slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  ...
 */
function mapReducer(state = initialState, action) {

    switch (true) {

        case (action.type === STORE_RESET):
            
            state = {
                ...state,
                refs: {
                    ...initialState.refs
                },
                data: initialState.data,
                staticImageUrl: initialState.staticImageUrl
            };
            break;

        case (action.type === MAP_UPDATE):

            state = {
                ...state,
                refs: {
                    ...state.refs,
                    ...action.payload.refs
                },
                data: {
                    ...state.data,
                    ...action.payload.data
                }
            };
            break;

        case (action.type === MAP_STATIC_IMAGE_URL_UPDATE):

            state = {
                ...state,
                staticImageUrl: action.payload.url
            };
            break;

        default:

    }

    return state;
};

export default mapReducer;